import './CouponCarousel.scss';

import React from 'react';
import ReactDOM from 'react-dom';

import Slider from 'react-slick';
import '../../../node_modules/slick-carousel/slick/slick.css';
import '../../../node_modules/slick-carousel/slick/slick-theme.css';

import Service from './CouponCarouselService';
import Screen from '../../Shared/Helpers/Screen';

const CouponUrl = (coupon) => {
    return `/Special-Offers/${coupon.id}`;
};
const ValidDate = () => {
     var d = new Date();
     d.setDate(d.getDate() + 14);
     return d.toLocaleDateString();
};

let Coupon = (props) => {
    let coupon = props.coupon;
    return (
        //<div className="coupon-box">
        //    <div className="coupon-header hidden-xs">
        //        <img className="logo" src="/images/shared/logo.svg" alt="Aamco" />
        //    </div>
        //    <div className="coupon-content">
        //        <h3 className="coupon-title">{coupon.name}</h3>
        //        <h4 className="coupon-subtitle">{coupon.title}</h4>
        //        <div className="coupon-info" dangerouslySetInnerHTML={{ __html: coupon.description }}></div>

        //        <a href={`${CouponUrl(coupon)}`} className="cta-btn coupon-btn">GET COUPON</a>
        //    </div>
        //</div>

        <section className="coupon">
            <header className="coupon-header">
                <h3>{coupon.name}</h3>
                {
                    coupon.image.alt == "" &&
                    <img src={`${coupon.image.websitePath}`} alt={coupon.name} />
                }
                {
                    coupon.image.alt != "" &&
                    <img src={`${coupon.image.websitePath}`} alt={coupon.image.alt} />
                }

            </header>
            <div className="coupon-content">
                <div className="coupon-content-text">
                    <h4>{coupon.title}</h4>
                    <div className="hidden-xs wysiwyg-content" dangerouslySetInnerHTML={{ __html: coupon.description }}></div>
                </div>

                <div className="coupon-footer">
                    <div className="coupon-footer-info">
                        <p><b>Offer good thru:</b> {ValidDate()}</p>
                        <p><b>Valid at Participating Centers of:</b> @domainOption.Region.Name</p>
                    </div>
                    <a href={`${CouponUrl(coupon)}`} className="apply-btn alert-btn">GET COUPON</a>
                    <a href={`${CouponUrl(coupon)}`} className="coupon-btn-more">more details</a>
                </div>
            </div>
        </section>

    );
}

let CouponMobile = (props) => {
    let coupon = props.coupon;

    return (
        <div className="coupon-box">
            <div className="coupon-content">
                <h3 className="coupon-title">{coupon.name}</h3>
                <h4 className="coupon-subtitle">{coupon.title}</h4>

                <a href={`${CouponUrl(coupon)}`} className="read-more-link">Read more</a>
            </div>

            <img className="icon" src={coupon.icon && coupon.icon.websitePath} alt="coupon-icon"></img>
        </div>
    );
}

let PrevArrow = (props) => {
    return (<img className={props.className}
            src="/images/shared/Carousel/prev-arrow.svg"
            onClick={props.onClick}
            alt="prev-arrow"/>);
}

let NextArrow = (props) => {
    return (
        <img className={props.className}
            src="/images/shared/Carousel/next-arrow.svg"
            onClick={props.onClick}
            alt="next-arrow"/>);
}

export default class CouponCarousel extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            coupons: [],
            mobileShownItems: 3
        };

        this.LOAD_MORE_ITEMS = 3;

        this.loadMore = this.loadMore.bind(this);
    }

    componentDidMount() {

        if (window.location.href.indexOf("Transmission-Services") > -1) {

            let data = Service.getTransmissionCoupons()
                .then((res) => {
                    this.setState({
                        coupons: res
                    });
                });
        }
        else {
            let data = Service.getAutoCareCoupons()
                .then((res) => {
                    this.setState({
                        coupons: res
                    });
                });
        }
      
    }

    render() {

        let settings = {
            slidesToShow: 3,
            slidesToScroll: 1,
            nextArrow: <NextArrow />,
            prevArrow: <PrevArrow />,
            infinite: false,
            arrows: this.state.coupons.length>3?true:false
            
            
        };
     
        return Screen.isMobile ?
            <MobileCouponView
                coupons={this.state.coupons}
                visibleAmount={this.state.mobileShownItems}
                loadMore={this.loadMore} /> :
            <DesktopCouponView settings={settings} coupons={this.state.coupons} />;
    }

    loadMore() {
        this.setState((prevState, props) => {
            return {
                mobileShownItems: prevState.mobileShownItems + this.LOAD_MORE_ITEMS
            }
        });
    }
}

function MobileCouponView(props) {
    let coupons = props.coupons.map((item, index) => {
        return (<CouponMobile coupon={item} key={index} />);
    });

    let filteredCoupons = coupons.filter((item, index) => {
        return index < props.visibleAmount;
    });

    let loadMoreBtn = <button className="action-btn" onClick={props.loadMore}>Load more</button>;

    return (
        <div className="coupon-mobile visible-xs">
            {filteredCoupons}
            {filteredCoupons.length < coupons.length ? loadMoreBtn : null}
        </div>
    );
}

function DesktopCouponView(props) {
    let couponList = props.coupons.map((item, index) => {
        return (<div key={index}>
            <Coupon coupon={item} />
        </div>);
    });

    return (<div className="coupon-carousel hidden-xs">
        {
            props.coupons.length != 0 &&
        <div className="title">
            CURRENT OFFERS & SPECIALS
          </div>
        }
        <Slider {...props.settings}>
            {couponList}
        </Slider>
    </div>);
}

ReactDOM.render(<CouponCarousel />,
    document.getElementById('coupons-section'));


// WEBPACK FOOTER //
// ./Src/Services/CouponCarousel/CouponCarousel.jsx